import { Chip } from '@mui/material'

interface ChipProps {
    status: string
}

type StatusChipColours = {
    backgroundColor: string
    borderColor: string
}

export const statusChipColour = (status: string): StatusChipColours | undefined => {
    switch (status) {
        case 'Live':
            return {
                backgroundColor: 'rgba(230, 242, 234, 1)',
                borderColor: 'rgba(0, 120, 49, 1)',
            }
        case 'Scheduled':
            return {
                backgroundColor: 'rgba(255, 245, 219, 1)',
                borderColor: 'rgba(202, 162, 51, 1)',
            }
        case 'Paused':
            return {
                backgroundColor: 'rgba(250, 232, 230, 1)',
                borderColor: 'rgba(220, 128, 122, 1)',
            }
        case 'Concluded':
            return {
                backgroundColor: 'rgba(230, 240, 247, 1)',
                borderColor: 'rgba(0, 101, 173, 1)',
            }
        case 'Archived':
            return {
                backgroundColor: 'rgba(244, 244, 244, 1)',
                borderColor: 'rgba(140, 140, 140, 1)',
            }
    }
}

export const StatusChip = ({ status }: ChipProps) => {
    const chipColours = statusChipColour(status)
    return (
        <Chip
            sx={{
                margin: '4px',
                minWidth: '90px',
                ...chipColours,
                color: 'rgba(14, 14, 14, 1)',
                // Disable hover effect
                '&:hover': {
                    backgroundColor: chipColours?.backgroundColor,
                    borderColor: chipColours?.borderColor,
                    color: 'rgba(14, 14, 14, 1)',
                },
            }}
            label={status}
            variant="outlined"
            size="small"
            data-test="status-chip"
        />
    )
}
